<template>
  <div>
    <div class="view-framework">
    	<userLeft></userLeft>
      <div class="view-framework-body">
      	<div class="view-framework-main">
      		<div class="box">
      			<h2 class="box-caption">快速结算</h2>
            <div class="userform">
              <div class="form-group">
                <div v-if="!subAppli">
										<h1 v-if="buttBoo">{{problemNumber+1}}·{{suveList[problemNumber].title}}</h1>
										<h1 v-else>{{problemNumber+2}}·{{fProblem.title}}</h1>
                    <div class="mt30">
                      <div v-if="buttBoo">
                      	<el-radio-group v-model="desc_id" class="fwefhhh">
                      		<el-radio :label="item.id" size="large" v-for="(item,index) in proDcit.desc" :key="index">
                      			{{item.content}}
                      		</el-radio>
                      	</el-radio-group>
                      </div>
                      <div v-else>
                      	<el-checkbox-group v-model="checkList" class="fwefhhh-checkbox">
                      		<el-checkbox :label="item.content" v-for="(item,index) in fProblem.desc" :key='index' />
                      	</el-checkbox-group>
                      </div>
                    </div>

                  <div class="form-group-btn mt30" style="padding-left: 0;">
                  	<button class="btn btn-primary"  @click='openNext'>下一步</button>
                  </div>
                </div>
                <div v-else>
                	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm" label-position="left">
                		<el-form-item label="订单号" prop="order_no">
                			<el-input v-model="ruleForm.order_no" disabled></el-input>
                		</el-form-item>
                		<el-form-item label="卡种" prop="goods_name">
                			<el-input v-model="ruleForm.goods_name" disabled></el-input>
                		</el-form-item>
                		<el-form-item label="卡号" prop="card">
                			<el-input v-model="ruleForm.card" disabled></el-input>
                		</el-form-item>
                		<el-form-item label="卡密" prop="card_pass">
                			<el-input v-model="ruleForm.card_pass" disabled></el-input>
                		</el-form-item>
                		<el-form-item label="结算时间" prop="result_date">
                			<el-input v-model="ruleForm.result_date" disabled></el-input>
                		</el-form-item>
                		<el-form-item label="备注" prop="remark">
                			<el-input type="textarea" v-model="ruleForm.remark"></el-input>
                		</el-form-item>
                		<el-form-item label="卡密来源证明视频" prop="imgList">
                			<video v-if="imageUrl.length !=0 " :src="ruleForm.imgList[0].file_path" class="avatar-video" :controls="true" :autoplay="false" ></video>
                			<el-upload
                				v-else
                				class="avatar-uploader"
                				list-type="picture-card"
                				:action='baseUrl + "/api/upload/image"'
                				:on-success="handleAvatarSuccess"
                				:before-upload="beforeAvatarUpload"
                				:on-error="handleVideoError"
                				:on-preview="handlePictureCardPreview"
                				name="iFile"
                				:headers="{
                					'Access-Token':token
                				}"

                			>

                				<i class="el-icon-plus"></i>
                			</el-upload>

                		</el-form-item>
                		<el-form-item>
                      <button class="btn btn-primary  btn-lg btn-sellform"  @click="submitForm('ruleForm')" >提交</button>
                			<!-- <el-button color="#0EB6FF"  class="settie-buttfona mt40" ></el-button> -->
                		</el-form-item>
                	</el-form>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import config from '@/config.js'
	export default{
		data(){
			return{
				issueList:[],
				suveList:[
					{}
				],
				proDcit:[],
				problemNumber:0,
				fProblem:{
					title:'请仔细阅读以下内容并勾选！',
					desc:[
						{
							content:'我本人承诺该帐号一直是本人使用，没有出租、出借、出卖给他人使用。',
							bool:false
						},
						{
							content:`我本人承诺在吉吉收提交的卡劵来源合法合规。`,
							bool:false
						},
						{
							content:'我本人承诺在本次尽职调查所填写的内容和上传的材料都是本人操作，并且真实有效。',
							bool:false
						}
					]
				},
				checkList:[],
				desc_id:"",
				buttBoo:true,
				subAppli:false,
				tableData:{},
        ruleForm: {
					goods_name:"",
					order_no:"",
          remark: '',
					card:"",
					card_pass:"",
					result_date:"",
					imgList:[]
        },
        rules: {
          remark: [
            { required: true, message: '请填写备注', trigger: 'blur' }
          ],
					imgList: [
					  { required: true, message: '请填加卡券来源视频', trigger: 'blur' }
					]
        },
				imageUrl:[],
				config,
				token:localStorage.getItem('token'),
				loading:false,
        baseUrl:""
			}
		},
		components:{

		},
		created() {
      this.baseUrl = config.apiUrl;
			this.getData()
			this.alwaysFunc()
		},
		methods:{
			handlePictureCardPreview(file){
				// this.dialogImageUrl = file.url;
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl.push(res.data)
				this.ruleForm.imgList = this.imageUrl
			},
			handleVideoError(error,uploadFile,uploadFiles){
        this.$message({
        	message: error,
        	type: 'error'
        });
			},
			beforeAvatarUpload(file) {
        const fileSize = file.size / 1024 / 1024 < 300
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
          this.$message({
          	message: '请上传正确的视频格式',
          	type: 'warning'
          });
          return false
        }
        if (!fileSize) {
          this.$message({
          	message: '视频大小不能超过300MB',
          	type: 'warning'
          });
          return false
        }
			},
			getData(){
				this.$api.orderList({
					type:1,
					page:1,
					name:this.$route.query.order_no
				})
				.then(result => {
					this.tableData = result.data.data[0]
					for(let k in this.ruleForm){
						this.ruleForm[k] = this.tableData[k]
					}
					this.ruleForm['remark'] = ''
					// this.ruleForm(pick(this.tableData, ['card','card_pass']))
				})
			},
			settlementsubmit(){
				this.loading = true
        let token = localStorage.getItem('token')
				let user_id = JSON.parse(localStorage.getItem("userInfo")).user_id;
				this.$api.settlementsubmit({
					order_id:this.tableData.order_no,
					user_remark:this.ruleForm.remark,
					image:this.ruleForm.imgList[0].file_id,
					user_id,
          // token,
				})
				.then(result => {
          console.log(result)
					if(result.code === 1){
						this.loading = false
            this.$message({
            	message: '提交成功',
            	type: 'success'
            });
						setTimeout(() => {
							this.$router.push({path:'/order'})
						},1000)
					}
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.settlementsubmit()
					} else {
						return false;
					}
				});
			},

			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			openNext(){
				if(this.buttBoo){
					this.$api.surveysubmitl({
						desc_id:this.desc_id
					})
					.then(result => {
            console.log(result)
						if(result.code === 1){
							if(this.problemNumber + 1 < this.suveList.length){

								this.problemNumber += 1;
								this.problemDetail();
							}else{
								this.buttBoo = false;
							}
						}else{
							localStorage.setItem('surveyStatus',this.$route.query.order_no + '|' + Date.parse(new Date()) / 1000)
						}
					})
				}else{
					this.subAppli = true
				}
			},
			async alwaysFunc(){
				this.suveList = await this.surveyList()
				this.problemDetail()
			},
			async problemDetail(){
				let list = await this.surveydesc(this.suveList[this.problemNumber].id)
				// list.desc = this.changeData(list.desc)
				this.proDcit = list
				console.log(this.proDcit)
			},
			surveyList(){
				return new Promise((resolve,reject) => {
					this.$api.surveyList({
					})
					.then(result => {
						resolve(result.data);
					})
				})
			},
			surveydesc(id){
				return new Promise((resolve,reject) => {
					this.$api.surveydesc({
						id,
					})
					.then(result => {
						resolve(result.data)
					})
				})
			},
		}
	}
</script>

<style scoped>
/*  /deep/.el-radio__label{
    font-size: 16px;
  } */
/*  /deep/.el-radio.el-radio--large{
  	width: 100%;
  }
  /deep/.el-radio.el-radio--large .el-radio__input .el-radio__inner{
  	width: 20px;
  	height: 20px;
  }
  /deep/.el-radio.el-radio--large .el-radio__input .el-radio__inner::after{
  	width: 8px;
  	height: 8px;
  } */
  /deep/.fwefhhh .el-radio__input.is-checked+.el-radio__label{
    /* color: #000; */
  }
  /deep/.fwefhhh .el-radio__input.is-checked .el-radio__inner{
    /* background-color: #000; */
  }
  /deep/.fwefhh .el-radio .el-radio__input .el-radio__inner:hover{
    /* border-color: #000; */
  }
  /deep/.fwefhhh .el-radio .el-radio__label{
    font-size: 16px;
  }
  /deep/.fwefhhh .el-radio{
  	width: 100%;
    margin-top: 16px;
  }

  /deep/.fwefhhh-checkbox .el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner{
/*     background-color: #000;
      border-color: #000; */
  }
  /deep/ .fwefhhh-checkbox .el-checkbox .el-checkbox__inner:hover{
    /* border-color: #000; */
  }
  /deep/ .fwefhhh-checkbox .el-checkbox .el-checkbox__inner:active{
    /* border-color: #000; */
  }
  /deep/.fwefhhh-checkbox .el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label{
    /* color: #000; */
  }
  /deep/.fwefhhh-checkbox .el-checkbox{
    width: 100%;
  }
  /deep/.fwefhhh-checkbox .el-checkbox .el-checkbox__label{
    font-size: 16px;
  }
/*  /deep/.el-checkbox__inner{
  	width: 20px;
  	height: 20px;
  }
  /deep/.el-checkbox__inner::after{
  	width: 5px;
  	height: 12px;
  	left: 6px;
  }
  /deep/.el-checkbox__label{
  	font-size: 20px;
  }
  /deep/.el-checkbox+.el-checkbox{
  	margin-top: 20px;
  }


  /deep/.el-form-item__label{
  	font-size: 20px;
  }
  /deep/.el-input.is-disabled{
  	height: 40px
  }
  /deep/.el-textarea__inner{
  	min-height: 80px!important;
  }
  /deep/.el-form-item__content input{
  	font-size: 20px;
  }
  /deep/.el-form-item__content textarea{
  	font-size: 20px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/user/settle.vue